<div class="bg-primary py-5">
    <div class="container-fluid">
        <div class="col-12">
            <div class="row mb-0">
                @for(item of icons; track $index){
                    <div class="col-3">
                        <div class="d-flex align-items-center justify-content-center h-100">
                            <img class="icon" [src]="item" alt="">
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>